import React from 'react';

export interface IAppContext {
  isAuthenticated: boolean | undefined;
  roles: string[];
  updateRoles: (roles: string[]) => void;
  setStatus: (status: string | undefined) => void;
}

export const AppContext = React.createContext<IAppContext>({
  isAuthenticated: undefined,
  roles: [],
  updateRoles: () => { },
  setStatus: () => { },
});